import {
	// New fields
	INPUT_CONTACT_SCHOOL_NAME,
	INPUT_CONTACT_CLASS_NAME,
	INPUT_CONTACT_COMMITTEE_PRESIDENT,
	INPUT_CONTACT_COMMITTEE_PHONE,
	INPUT_CONTACT_COMMITTEE_EMAIL,
	INPUT_CONTACT_CLASS_PRESIDENT,
	INPUT_CONTACT_CLASS_PHONE,
	INPUT_CONTACT_CLASS_EMAIL,
	INPUT_CONTACT_DATE_PROM,
	INPUT_CONTACT_GUESTS_NUM,
	// New regular fields
	INPUT_CONTACT_PHONE,
	INPUT_CONTACT_DATE_EVENT,
	INPUT_CONTACT_TYPE_EVENT,
	// Original fields
	INPUT_CONTACT_NAME,
	INPUT_CONTACT_EMAIL,
	INPUT_CONTACT_MSG,
	SET_CONTACT_DB,
	SET_CONTACT_STATUS
} from '../actions/Types';

const INITIAL_STATE = {	
	schoolName: '',
	className: '',
	commPresident: '',
	commPhone: '',
	commEmail: '',
	classPresident: '',
	classPhone: '',
	classEmail: '',
	dateProm: '',
	guestsNumber: '',
	// New regular fields
	phone: '',
	dateEvent: '',
	typeEvent: '',
	// Original fields
	name: '',
	email: '',
	msg: '',
	emailDB: '',
	status: ''
}

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case INPUT_CONTACT_SCHOOL_NAME:
			return { ...state, schoolName: action.payload };
		case INPUT_CONTACT_CLASS_NAME:
			return { ...state, className: action.payload };
		case INPUT_CONTACT_COMMITTEE_PRESIDENT:
			return { ...state, commPresident: action.payload };
		case INPUT_CONTACT_COMMITTEE_PHONE:
			return { ...state, commPhone: action.payload };
		case INPUT_CONTACT_COMMITTEE_EMAIL:
			return { ...state, commEmail: action.payload };
		case INPUT_CONTACT_CLASS_PRESIDENT:
			return { ...state, classPresident: action.payload };
		case INPUT_CONTACT_CLASS_PHONE:
			return { ...state, classPhone: action.payload };
		case INPUT_CONTACT_CLASS_EMAIL:
			return { ...state, classEmail: action.payload };
		case INPUT_CONTACT_DATE_PROM:
			return { ...state, dateProm: action.payload };
		case INPUT_CONTACT_GUESTS_NUM:
			return { ...state, guestsNumber: action.payload };
		// New regular fields
		case INPUT_CONTACT_PHONE:
			return { ...state, phone: action.payload };
		case INPUT_CONTACT_DATE_EVENT:
			return { ...state, dateEvent: action.payload };
		case INPUT_CONTACT_TYPE_EVENT:
			return { ...state, typeEvent: action.payload };
		// Original fields
		case INPUT_CONTACT_NAME:
			return { ...state, name: action.payload };
		case INPUT_CONTACT_EMAIL:
			return { ...state, email: action.payload };
		case INPUT_CONTACT_MSG:
			return { ...state, msg: action.payload };
		case SET_CONTACT_DB:
			return { ...state, emailDB: action.payload };
		case SET_CONTACT_STATUS:
			return { ...state, status: action.payload };
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/ContactReducer.js